// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { COUPON_CLICK_TYPE, COUPON_PAGE_TYPE } from './constants';

export const onCouponClick = ({
  pageType,
  couponClickType,
}: {
  pageType: string;
  couponClickType: string;
}) => {
  NFA.updateDataLayer({
    offerPageType:
      pageType == COUPON_CLICK_TYPE.COUPON
        ? COUPON_PAGE_TYPE.COUPON_LISTING_TYPE
        : COUPON_PAGE_TYPE.OFFER_LISTING_TYPE,
    siteSubProductNavigation: couponClickType,
  });
};
